import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


export function httpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {

	let version = '3.7.1025';  // не забывать исправлять и в globals.ts и  в db_version.php

  return new TranslateHttpLoader(httpClient, '/assets/i18n/', '.json?' + version); // TODO есть ли использование в /angular/ ?
}
